import { poll } from 'lib/poll';
import { millisecond } from 'config/constants';
import { SelfServiceAPI } from 'apis';
import { SelfServiceAPI as SelfServiceAPIType } from 'types';

interface Data extends SelfServiceAPIType.CreateGuestAmendment.Request {
  bookingId: string;
}

export const processGuestAmendment = async (data: Data) => {
  const createResult = await SelfServiceAPI.createGuestAmendment(data);
  const amendmentId = createResult.id;

  if (!amendmentId) {
    throw new Error('Failed creating amendment');
  }

  const { bookingId } = data;

  const quotedResult = await poll({
    requestFn: () => SelfServiceAPI.getAmendment({ bookingId, amendmentId }),
    isFinished: (result) => result.amendment.state !== 'QUOTING',
    timeoutMs: millisecond.MINUTE,
  });

  if (quotedResult.amendment.state !== 'QUOTED') {
    throw new Error(`Expected amendment to be "QUOTED" but state was "${quotedResult.amendment.state}"`);
  }

  if (quotedResult.amendment.amendmentTotal?.type !== 'NO_PAYMENT') {
    throw new Error(`Expected non financial amendment`);
  }

  await SelfServiceAPI.acceptAmendment({ bookingId, amendmentId });

  const acceptedResult = await poll({
    requestFn: () => SelfServiceAPI.getAmendment({ bookingId, amendmentId }),
    isFinished: (result) => result.amendment.state !== 'ACCEPTING',
    timeoutMs: millisecond.MINUTE,
  });

  if (acceptedResult.amendment.state !== 'ACCEPTED') {
    throw new Error(`Expected amendment to be "ACCEPTED" but state was "${acceptedResult.amendment.state}"`);
  }

  return acceptedResult.amendment;
};
